import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LeftNav from '../common/LeftNav';
import TopNav from '../common/TopNav';
import adminCrmService from '../../../services/adminCrmService';
import '../../../assets/styles/PersonalIDs.css';
import '../../assets/styles/CRMOpenLead.css';
import '../../assets/styles/Ratings.css';
import arrowleftt from '../../assets/img/arrowleftt.svg';

const formatDate = (d) => {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

export default function AdminCrmReviews() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userId, userName, userRole, userEmail, userPhone } = location.state || {};

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => { if (userId) fetchReviews(); }, [userId]);

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const res = await adminCrmService.getUserReviews(userId);
      if (res.success) setData(res.data);
    } catch (err) { console.error('Fetch reviews error:', err); }
    finally { setLoading(false); }
  };

  const summary = data?.summary || { total_reviews: 0, positive_count: 0, negative_count: 0, avg_rating: 0 };
  const allReviews = data?.reviews || [];
  const filteredReviews = filter === 'all' ? allReviews : allReviews.filter(r => r.review_type === filter);

  const totalLikes = summary.positive_count || 0;
  const totalDislikes = summary.negative_count || 0;
  const total = summary.total_reviews || 1;
  const likePercent = (totalLikes / total) * 100;
  const dislikePercent = (totalDislikes / total) * 100;

  return (
    <div className="d-flex" style={{ background: '#fff', minHeight: '100vh' }}>
      <LeftNav />
      <div className="main-content flex-grow-1">
        <TopNav />
        <div className="p-3">

          {/* Back + Title */}
          <div className="d-flex align-items-center gap-2 mb-3">
            <img src={arrowleftt} onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} alt="back" />
            <h6 className="accordion-title mb-0">Ratings & Reviews</h6>
          </div>

          {userName && <p style={{ fontSize: '13px', fontWeight: '600', color: '#6B7280', marginBottom: '12px' }}>{userName}</p>}

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
            </div>
          ) : (
            <>
              {/* Summary Card */}
              <div className="accordion-item mb-3">
                <div className="accordion-header d-flex justify-content-between align-items-center" style={{ cursor: 'default' }}>
                  <h6 className="accordion-title mb-0">Summary</h6>
                </div>
                <div className="accordion-body">
                  <div className="card p-4 personal-ids-card">
                    <div className="crm-openlead-container">
                      {/* Toggle row */}
                      <div className="review-summary">
                        <div className="toggle-row mb-3">
                          <div className="toggle-group">
                            <div
                              className={`switch-toggle ${filter === 'positive' ? 'on-like' : ''}`}
                              onClick={() => setFilter(f => f === 'positive' ? 'all' : 'positive')}
                            >
                              <div className="switch-track px-2"></div>
                              <div className="switch-thumb">👍</div>
                              <span className="switch-count">{totalLikes}</span>
                            </div>
                            <div
                              className={`switch-toggle ${filter === 'negative' ? 'on-dislike' : ''}`}
                              onClick={() => setFilter(f => f === 'negative' ? 'all' : 'negative')}
                            >
                              <div className="switch-track"></div>
                              <div className="switch-thumb">👎</div>
                              <span className="switch-count">{totalDislikes}</span>
                            </div>
                          </div>
                        </div>
                        {/* Progress bar */}
                        <div className="progress-bar-container mb-3">
                          <div className="progress-like" style={{ width: `${likePercent}%` }}></div>
                          <div className="progress-dislike" style={{ width: `${dislikePercent}%` }}></div>
                        </div>
                      </div>

                      {/* Stats */}
                      <div className="d-flex gap-3 mb-2">
                        <div className="flex-grow-1 text-center p-2" style={{ backgroundColor: '#FFF7ED', borderRadius: '10px' }}>
                          <div style={{ fontSize: '22px', fontWeight: '800', color: '#F59E0B' }}>{summary.avg_rating || 0}</div>
                          <div style={{ fontSize: '10px', color: '#6B7280' }}>⭐ Avg Rating</div>
                        </div>
                        <div className="flex-grow-1 text-center p-2" style={{ backgroundColor: '#F3F4F6', borderRadius: '10px' }}>
                          <div style={{ fontSize: '22px', fontWeight: '800', color: '#374151' }}>{summary.total_reviews}</div>
                          <div style={{ fontSize: '10px', color: '#6B7280' }}>Total</div>
                        </div>
                        <div className="flex-grow-1 text-center p-2" style={{ backgroundColor: '#F0FDF4', borderRadius: '10px' }}>
                          <div style={{ fontSize: '22px', fontWeight: '800', color: '#059669' }}>{totalLikes}</div>
                          <div style={{ fontSize: '10px', color: '#6B7280' }}>Positive</div>
                        </div>
                        <div className="flex-grow-1 text-center p-2" style={{ backgroundColor: '#FEF2F2', borderRadius: '10px' }}>
                          <div style={{ fontSize: '22px', fontWeight: '800', color: '#DC2626' }}>{totalDislikes}</div>
                          <div style={{ fontSize: '10px', color: '#6B7280' }}>Negative</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Filter chips */}
              <div className="d-flex gap-2 mb-3">
                {[{ key: 'all', label: 'All' }, { key: 'positive', label: 'Positive' }, { key: 'negative', label: 'Negative' }].map(f => (
                  <button
                    key={f.key}
                    onClick={() => setFilter(f.key)}
                    style={{
                      padding: '8px 16px', borderRadius: '20px', cursor: 'pointer',
                      border: `1px solid ${filter === f.key ? '#2563EB' : '#E5E7EB'}`,
                      backgroundColor: filter === f.key ? '#2563EB' : '#fff',
                      color: filter === f.key ? '#fff' : '#6B7280',
                      fontSize: '13px', fontWeight: '500'
                    }}
                  >{f.label}</button>
                ))}
              </div>

              {/* Reviews list */}
              {filteredReviews.length === 0 ? (
                <div className="text-center py-5">
                  <div style={{ fontSize: '48px' }}>⭐</div>
                  <div style={{ fontSize: '17px', fontWeight: '600', color: '#374151', marginTop: '12px' }}>No Reviews</div>
                  <div style={{ fontSize: '14px', color: '#9CA3AF', marginTop: '6px' }}>No reviews found for this user</div>
                </div>
              ) : (
                filteredReviews.map((review, index) => (
                  <div key={review.id || index} className="review-card mb-2">
                    <div className="review-header">
                      <div className="reviewer-info">
                        <div style={{
                          width: '36px', height: '36px', borderRadius: '18px', flexShrink: 0,
                          backgroundColor: review.review_type === 'positive' ? '#D1FAE5' : '#FEE2E2',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: '16px'
                        }}>
                          {review.review_type === 'positive' ? '👍' : '👎'}
                        </div>
                        <div>
                          <span className="reviewer-name">{review.reviewer_name || 'Anonymous'}</span>
                          {review.reviewer_role && (
                            <div style={{ fontSize: '11px', color: '#9CA3AF', textTransform: 'capitalize' }}>{review.reviewer_role}</div>
                          )}
                        </div>
                      </div>
                      <div className="text-end">
                        {review.rating && (
                          <span style={{ backgroundColor: '#FFF7ED', color: '#F59E0B', padding: '2px 6px', borderRadius: '6px', fontSize: '12px', fontWeight: '600' }}>
                            {review.rating} ⭐
                          </span>
                        )}
                        <div className="review-date" style={{ marginTop: '4px' }}>{formatDate(review.created_at)}</div>
                      </div>
                    </div>
                    {review.review && <p className="review-text">{review.review}</p>}
                    <div className="review-footer">
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#9CA3AF' }}>
                        👍 <span>{review.likes || 0}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#9CA3AF' }}>
                        👎 <span>{review.dislikes || 0}</span>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
